import React from "react";
import { motion } from "framer-motion";

const features = [
  {
    title: "Our Mission",
    description: "To democratize access to startup resources and connections.",
    icon: "https://cdn.lordicon.com/puvaffet.json",
  },
  {
    title: "Our Vision",
    description: "A world where anyone with a great idea can build a successful company.",
    icon: "https://cdn.lordicon.com/etqbfrgp.json",
  },
  {
    title: "Our Team",
    description: "Experienced entrepreneurs, investors, and technologists.",
    icon: "https://cdn.lordicon.com/bgebyztw.json", // Changed to a visible and relevant animated team icon
  },
  {
    title: "Our Partners",
    description: "Leading VCs, accelerators, and corporate innovation programs.",
    icon: "https://cdn.lordicon.com/kthelypq.json",
  },
];

const AboutFeatures = () => {
  return (
    <>
      {/* Lordicon script */}
      <script src="https://cdn.lordicon.com/lordicon.js"></script>

      <section className="w-full bg-white px-4 py-8 md:py-10 lg:py-12">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 mb-10">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                className="flex items-start space-x-4"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <div className="p-3 rounded-full bg-blue-50">
                  <lord-icon
                    src={feature.icon}
                    trigger="loop"
                    delay="2000"
                    style={{ width: "40px", height: "40px" }}
                    colors="primary:#004a99"
                  ></lord-icon>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800">
                    {feature.title}
                  </h4>
                  <p className="text-gray-600 text-sm md:text-base">
                    {feature.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            className="text-center"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
              className="bg-[rgb(0,74,153)] hover:bg-[#042C6B] text-white font-medium py-2 px-6 rounded-md transition-colors duration-1000 ease-in-out"
            >
              Learn More About Us
            </motion.button>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default AboutFeatures;
